export default __webpack_public_path__ + "static/logo-intrander-91ea47c99664fb442961a6e510e41bd6.png";